import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const PageActionsListMenuButton = ({
   description,
   icon,
   name
}) => (
   <View
      display="flex"
      width="100%"
      borderBottom="1px solid rgba(255,255,255,0.1)"
      padding="18px 24px"
      className={css`
         cursor: pointer;

         &:hover {
            background-color: #444;
         }
      `}>
      <View
         flex="0 0 auto"
         width="18px"
         height="18px"
         marginTop="6px"
         marginRight="18px">
         {icon}
      </View>
      <View flex="1 1 auto">
         <Text size="1.5" color="rgba(255,255,255,1)" weight="medium">
            {name}
         </Text>
         <View float="left" width="100%" height="3px" />
         <Text size="1.5" color="rgba(255,255,255,0.5)">
            {description}
         </Text>
      </View>
   </View>
)

PageActionsListMenuButton.propTypes = {
   description: PropTypes.string.isRequired,
   icon: PropTypes.node,
   name: PropTypes.string.isRequired
}

PageActionsListMenuButton.defaultProps = {
   icon: undefined
}

export default PageActionsListMenuButton
